<template>
  <footer class="zui-footer">
    <div class="container footer_box" style="display: flex; flex-wrap: wrap">
      <div class="item lxwm" style="color: white; margin-left: 50px">
        <p class="title" style="">友情链接</p>
        <div style="display: flex">
          <div>
            <!-- <p class="email">
              <a href="http://www.80580.net/" style="margin-right: 20px">电子保函公共资源交易中心</a>
            </p>
            <p class="email">
              <a href="https://www.spdb.com.cn/" style="margin-right: 20px">电子保函数据综合服务平台</a>
            </p> -->
            <p class="email">
              <a href="http://ggzy.ln.gov.cn/" style="margin-right: 20px">辽宁省公共资源交易中心</a>
            </p>
            <p class="email">
              <a href="https://ggzy.jz.gov.cn/" style="margin-right: 20px">锦州市公共资源交易中心</a>
            </p>
          </div>
        </div>
      </div>
      <div class="item lxwm lx_phone" style="color: white;margin-left: 147px;">
        <p class="title" style="color: white;">联系电话</p>
        <p class="phone">客服电话：18650093298</p>
        <p>商务合作：冯女士 13696880380 / 曾先生13665980888</p>
        <p class="email">公司地址：辽宁省锦州市松山新区黄海大街46-5号3楼</p>
      </div>
      
    </div>
    <div class="links" style="margin-top: 50px">
      <a href="javascript:;" @click="go('/','1')">首页</a>
      <a href="javascript:;" @click="go('Guarantee','2')">保函产品</a>
      <a href="javascript:;" @click="go('about','3')">助贷服务</a>
      <a href="javascript:;" @click="go('info','4')">资讯中心</a>
      <a href="javascript:;" @click="go('help','5')">保函查验</a>
      <a href="javascript:;" @click="go('Business','6')">注册登录</a>
    </div>
    <p class="copy-right" style="color: #888888;">
      声明：本平台仅提供技术支持，所有保函产品均由保函下发金融机构提供，销售、理赔等服务
      <br />
      @ 2024 锦州市保函综合服务有限公司版权所有 工信部备案号：<a href="https://beian.miit.gov.cn/">辽ICP备2024036003号-1</a>
    </p>
  </footer>
</template>
<script>
import "./less/footer.less";
export default {
  data() {
    return {};
  },
  methods: {
    go(n,e) {
      if(e=="6"){
           window.open(window.SITE_CONFIG.baseUrl +  '/social-login')
        }else{
          this.$router.push({
            path: n,
          });
        }
     
    },
  },
};
</script>
<style scope>
#aui-footer .footer_box {
  display: flex;
  justify-content: space-between;
  color: white;
}
.item p {
  color: white;
}
.email a {
  font-size: 14px;
font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 500;
color: #888888;
line-height: 20px;
}
.email a:hover{
  color: white;
}
.lx_phone>p{
  color: #888888;
}
@media screen and (min-width: 1024px) and (max-width: 3920px) {
  .title {
    margin-bottom: 22px;
    font-weight: 500;
    font-size: 22px;
  }
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .title {
    margin-bottom: 22px;
    font-size: 20px;
  }
  .item {
    margin-top: 50px;
    margin-left: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue